module.exports = __webpack_public_path__ + "56f06b46c709fe28ad15a7f1a6603897.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/cos/0C00000WJ8.png
// module id = 1642
// module chunks = 0